import { useWindowSize } from "./useWindowSize";
import { SizeClassComparer } from "./SizeClassComparer";
import { useMemo } from "react";

export const useWindowHeightComparer = (): SizeClassComparer => {
  const { windowHeight } = useWindowSize();
  return useMemo(() => new SizeClassComparer(windowHeight), [windowHeight]);
};
